import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { apiClient } from "../../../zodios/client";
import { errorToast, successToast } from "../../../utils/toasts";
import { useAppSelector } from "../../../redux/hooks";

type Payload = { user_id: number; rbac_role_id: number; status: string };

export const useModifyRoleMutation = () => {
  const { t } = useTranslation(["user_management"]);
  const user = useAppSelector((state) => state.user);

  const orgId = user.organization_id;

  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (vars: Payload) => {
      return await apiClient.updateUserRole(vars, { params: { org_id: orgId } });
    },

    onSuccess: () => {
      successToast({
        message: t(($) => $.user_management["User permissions successfully updated"]),
      });
      void queryClient.invalidateQueries({
        predicate: (query) => {
          const stringifiedQueryKey = JSON.stringify(query.queryKey);
          return stringifiedQueryKey.includes("userOrgPermissions") || stringifiedQueryKey.includes("orgUsers");
        },
      });
    },
    onError: (error) => {
      errorToast({ message: t(($) => $.user_management["Failed to update user permissions"]), error });
    },
  });
};
